import React, { createContext, useContext, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { Observer } from "./Observer";

const IntersectionContext = createContext({
  isInViewPort: false,
  setIsInViewPort: () => {}
});

export const useIntersectionContext = () => useContext(IntersectionContext);

export const IntersectionProvider = ({ children }) => {
  const [isInViewPort, setIsInViewPort] = useState(false);

  const contextValue = useMemo(
    () => ({
      isInViewPort,
      setIsInViewPort
    }),
    [isInViewPort]
  );

  return (
    <IntersectionContext.Provider value={contextValue}>
      <Observer setIsInViewPort={setIsInViewPort}>{children}</Observer>
    </IntersectionContext.Provider>
  );
};

IntersectionProvider.propTypes = {
  config: PropTypes.object,
  children: PropTypes.node,
  stickyPlayerContext: PropTypes.object
};
